interface CircleProps {
  radius: number
  centerX: number
  centerY: number
}

export const Circle = ({radius, centerX, centerY}: CircleProps) => {
  return (
    <>
      <svg
        className={`absolute w-[${centerX * 2}px] h-[${centerY * 2}px]`}
        viewBox={`0 0 ${centerX * 2} ${centerY * 2}`}
        preserveAspectRatio="none"
      >
        <circle cx={centerX} cy={centerY} r={radius} stroke="#52667A" strokeWidth={4} fill="none" />
      </svg>
    </>
  )
}
